export default __webpack_public_path__ + "static/media/skin-care-list.20ebe57a.png";